import { Heading, HFlow, Icon, VFlow } from 'bold-ui'
import { useAlert } from 'components/alert'
import { Form, FormRenderProps, getDefaultOnSubmitFailed, RadioGroupField } from 'components/form'
import { PopperButton, PopperControls } from 'components/popper'
import { FormState } from 'final-form'
import { MSG_ERRO_PREENCHIMENTO_OBRIGATORIO } from 'util/validation/messages/model'

import {
  AssinaturaEletronicaAtendTableFilterModel,
  CriterioExibicaoAtendimento,
  metaFilterAssinaturaEletronica,
  MSG_ERRO_PERIODO_INCOMPLETO,
} from '../model-assinaturaEletronicaAtend'
import { validateAssinaturaDigitalFilter } from '../validator-atendimentoDigital'
import AssinaturaEletronicaAtendTableFilterPopper from './AssinaturaEletronicaAtendTableFilterPopper'

const criterioExibicaoAtendimentoOptions = [
  {
    value: CriterioExibicaoAtendimento.TODOS_OS_ATENDIMENTOS,
    label: 'Todos os documentos',
  },
  {
    value: CriterioExibicaoAtendimento.ATENDIMENTOS_SEM_ASSINATURA,
    label: 'Sem assinatura',
  },
  {
    value: CriterioExibicaoAtendimento.ATENDIMENTOS_COM_ASSINATURA,
    label: 'Com assinatura',
  },
]

interface AssinaturaEletronicaAtendTableFilterProps {
  initialValues?: AssinaturaEletronicaAtendTableFilterModel
  disabled?: boolean
  onChange(values: AssinaturaEletronicaAtendTableFilterModel): void
}

export function AssinaturaEletronicaAtendTableFilter(props: AssinaturaEletronicaAtendTableFilterProps) {
  const { initialValues, disabled, onChange } = props

  const alert = useAlert()

  const handleSubmitFailed = (formState: FormState<AssinaturaEletronicaAtendTableFilterModel>) => {
    if (!formState.hasValidationErrors) return

    const erroPeriodo: string = formState.errors.periodo

    if (erroPeriodo) {
      alert('danger', erroPeriodo === MSG_ERRO_PREENCHIMENTO_OBRIGATORIO ? MSG_ERRO_PERIODO_INCOMPLETO : erroPeriodo)
    } else {
      getDefaultOnSubmitFailed<AssinaturaEletronicaAtendTableFilterModel>()(formState)
    }
  }

  const renderForm = ({ handleSubmit }: FormRenderProps<AssinaturaEletronicaAtendTableFilterModel>) => (
    <HFlow justifyContent='space-between' alignItems='flex-end'>
      <VFlow vSpacing={0.5}>
        <Heading level={5}> Exibir </Heading>
        <RadioGroupField
          name={metaFilterAssinaturaEletronica.criterioExibicao}
          options={criterioExibicaoAtendimentoOptions}
          onChange={handleSubmit}
          disabled={disabled}
        />
      </VFlow>

      <PopperButton
        kind='primary'
        size='small'
        skin='default'
        placement='bottom-end'
        focusOnOpen={false}
        renderPopper={(controls) => renderPopper(controls, handleSubmit)}
      >
        <Icon icon='filterOutline' />
        Filtros
      </PopperButton>
    </HFlow>
  )

  const renderPopper = (
    controls: PopperControls,
    handleSubmit: FormRenderProps<AssinaturaEletronicaAtendTableFilterModel>['handleSubmit']
  ) => {
    return <AssinaturaEletronicaAtendTableFilterPopper onClose={controls.close} onSubmit={handleSubmit} />
  }

  return (
    <Form<AssinaturaEletronicaAtendTableFilterModel>
      onSubmit={onChange}
      initialValues={initialValues}
      validate={validateAssinaturaDigitalFilter}
      onSubmitFailed={handleSubmitFailed}
      render={renderForm}
    />
  )
}
